import { Schema } from '../model/schema.model';
import { Food } from '../model/food.model';

/**
 * @param schema
 * @param day
 */
export function checkDay(schema, day) {
  day.plans.map(p => checkPlan(schema, p));
}

/**
 * @param schema
 * @param plan
 */
export function checkPlan(schema, plan) {
  plan.foods.map(f => checkRepeated(schema, f));
}

/**
 * @param schema
 * @param foodToCheck
 */
export function checkRepeated(schema, foodToCheck) {
  if (!(schema instanceof Schema)) {
    throw new Error('Unsupported schema type ' + typeof schema);
  }

  if (!(foodToCheck instanceof Food)) {
    throw new Error('Unsupported food type ' + typeof foodToCheck);
  }

  const occurrence = foodToCheck.date;
  const hash = foodToCheck.hash;
  const foodId = foodToCheck.id;

  if (!occurrence) {
    return;
  }

  schema.days.forEach(d => {
    d.plans.filter(p => p.foods.length > 0).forEach(p => {
      const food = p.findFood(hash, 'hash');

      if (!food || food.id === foodId) {
        return;
      }

      if (food.repeating.includes(occurrence)) {
        food.repeating = food.repeating.filter(d => d !== occurrence);
      } else {
        food.repeating.push(occurrence);
      }

      if (!foodToCheck.repeating.includes(food.date) && foodToCheck.date !== food.date) {
        foodToCheck.repeating.push(food.date);
      }
    });
  });

}


/**
 * @param schema
 * @param foodToCheck
 */
export function removeRepetition(schema, foodToCheck) {

  if (!(schema instanceof Schema)) {
    throw new Error('Unsupported schema type ' + typeof schema);
  }

  if (!(foodToCheck instanceof Food)) {
    throw new Error('Unsupported food type ' + typeof foodToCheck);
  }

  const occurrence = Number(foodToCheck.date);
  const hash = foodToCheck.hash;
  const foodId = foodToCheck.id;

  schema.days.forEach(d => {
    d.plans.filter(p => p.foods.length > 0).forEach(p => {

      const food = p.findFood(hash, 'hash');

      if (!food || food.id === foodId)
        return;

      if (food.repeating.includes(occurrence)) {
        food.repeating = food.repeating.filter(d => d !== occurrence);
      }
    });
  });
}
